import React from "react";
import Header from "./Header";
import {connect} from "react-redux";
import { logout} from "../../../store/auth-reducer";
import api from '../../../dataAccessLayer/firebase'



class HeaderContainer extends React.Component {
    componentDidMount() {

    }

    render() {
        return <Header {...this.props} api={api}/>
    }
}

const mapStateToProps = (state) => ({
    isAuth: state.auth.isAuth,
    name: state.auth.name
})

export default connect(mapStateToProps, { logout})(HeaderContainer);